function isValidNumber(value: number | null | undefined): value is number {
  return value !== null && value !== undefined && !Number.isNaN(value) && Number.isFinite(value);
}

const dollar4DecimalsValueFormatter = (value: number | null | undefined) => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 4,
    minimumFractionDigits: 4,
  }).format(value);
};

const dollarValueFormatter = (value: number | null | undefined) => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
};

const numberValueFormatter = (value: number | null | undefined) => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return Intl.NumberFormat('en-US').format(value);
};

const percentValueFormatter = (value: number | null | undefined) => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return Intl.NumberFormat('en-US').format(value) + '%';
};

export const formatters = Object.freeze({
  dollarValueFormatter,
  numberValueFormatter,
  percentValueFormatter,
  dollar4DecimalsValueFormatter,
});

const useNumberFormatters = () => formatters;

export default useNumberFormatters;
